import { TourBagIronSet } from '@/api/models/TourBagIronSet';
import { TourBagIronDetail } from '@/api/models/TourBagIronDetail';

export const createEmptyTourBagIronSet = (name: string): TourBagIronSet => ({
  // SharedModel props
  createDate: new Date(),
  modifyDate: new Date(),
  isActive: true,
  modifyUserGuid: '',
  modifyUserName: '',
  createUserGuid: '',
  rowGuid: '',
  tstamp: '',

  // Primary Keys
  tourBagMstrId: 0,
  tourBagIronSetId: 0,

  // Set Name
  tourBagIronSetName: name,

  // Hand
  hand: '',

  // Shaft
  shaftName: '',
  isShaftLengthFinished: false,
  shaftCosmetic: '',

  // Shaft Length
  // These fields are deprecated since Sets don't have shaft length
  // The API requires them for the op to succeed, so we assign default values them
  // shaftLengthDigit: '',
  // shaftLengthFraction: '',
  // shaftLengthDigitId: 0,
  // shaftLength_DigitId: 0,
  // shaftLengthFractionId: 0,
  // shaftLength_FractionId: 0,
  // Deprecated
  // tourBagMstr: null,

  // Swing Weight
  swingWtPrefixId: undefined,
  swingWtPrefixName: '',
  swingWtSuffixId: undefined,
  swingWtSuffixName: '',

  // Grip
  gripType: '',
  gripSize: '',
  gripSizeId: -1,
  gripTypeId: -1,
  tape: '',
  rndRib: '',
  logo: '',

  // Notes
  notes: '',

  // Iron List
  tourBagIronDetails: [] as TourBagIronDetail[],
});
